import GLOBALS from "./GLOBALS";
import snackbarMessages from "./snackbarMessages";
import axios from "axios";
import {Urls} from "./urls";
import API from "./api";
import {handleError} from "./handleError";


export const ReportService = {

    getReport: function (report_id, lang, variation, discarded, is_demo, includeComments, version) {

        const no_comments = includeComments ? "" : "&no_comments=true";      
        let permissions = JSON.parse(sessionStorage.getItem(GLOBALS.SESSION_KEYS.PERMISSIONS));
        const permission = GLOBALS.PERMISSIONS.GET_EVALUATION_INST;

        let report_endpoint;

        if(is_demo){
          report_endpoint = GLOBALS.ENDPOINTS.REPORTS.GET_INST_DEMO;
        }
        else {
          report_endpoint = GLOBALS.ENDPOINTS.REPORTS.GET_INST_USER;
        }

        if (permissions['reports']?.find((perm)=>(perm===permission)) && !is_demo) {
          report_endpoint = GLOBALS.ENDPOINTS.REPORTS.GET;
        }
        let endpoint = report_endpoint + "/" + report_id + "?lang=" + lang + no_comments;
        let isBlob = true;

        if (discarded !== undefined) {
          if (discarded) {
            endpoint = endpoint + "&discarded=true";
            isBlob = false;
          }
        }
        if (variation !== undefined) {
            endpoint = endpoint + "&variation=" + variation;
        }
        if (version !== undefined) {
            endpoint = endpoint + "&version=" + version;
        }

         return API.post(endpoint).then((response)=>{
           return response.data
          }).catch((error)=>{
            handleError(error, snackbarMessages.error.report.get);
         })
    },

    getLongitudinalReport: function (lang, evaluations, is_demo) {
      let report_endpoint;

      if (is_demo) {
        report_endpoint = GLOBALS.ENDPOINTS.REPORTS.GET_LONGITUDINAL_DEMO;
      } else {
        let permissions = JSON.parse(sessionStorage.getItem(GLOBALS.SESSION_KEYS.PERMISSIONS));
        const permission = GLOBALS.PERMISSIONS.GET_LONGITUDINAL_INST;

        report_endpoint = GLOBALS.ENDPOINTS.REPORTS.GET_LONGITUDINAL_INST_USER;
        if (permissions['reports']?.find((perm)=>(perm===permission))) {
          report_endpoint = GLOBALS.ENDPOINTS.REPORTS.GET_LONGITUDINAL_INST;
        }
      }
        let endpoint = report_endpoint + "/0" + "?lang=" + lang;

         return API.post(endpoint, {list: evaluations}).then((response)=>{
           return response.data
          }).catch((error)=>{
            handleError(error, snackbarMessages.error.report.get);
         })
    },

  listAllEvaluations: function(){
    let endpoint = GLOBALS.ENDPOINTS.REPORTS.ALL_EVALS;

    return API.get(endpoint + '/0').then((response) => {
        return response?.data?.data?.evaluations || []
    })
        .catch((error) => {
          handleError(error, snackbarMessages.error.report.get);
        })
  },

  getVariations: function(institution_id){
    let endpoint = GLOBALS.ENDPOINTS.REPORTS.GET_VARIATIONS_INST;

    return API.get(endpoint + '/' + institution_id).then((response) => {
        return response?.data?.data || []
    })
        .catch((error) => {
          handleError(error, snackbarMessages.error.report.getVariations);
        })
  },

  getObjects: function (id, type) {
    const is_demo = type?.is_demo || false;
    
    const permissions = JSON.parse(sessionStorage.getItem(GLOBALS.SESSION_KEYS.PERMISSIONS));
    const permission = GLOBALS.PERMISSIONS.LIST_REPORTS_INST;
    
    let endpoint, endpoint_user, list_endpoint;
    
    if (is_demo) {
      list_endpoint = GLOBALS.ENDPOINTS.REPORTS.LIST_INST_DEMO + "/0"; 
    } else {
        endpoint = GLOBALS.ENDPOINTS.REPORTS.LIST_INST;
        endpoint_user = GLOBALS.ENDPOINTS.REPORTS.LIST_INST_USER;

        if (permissions['reports']?.find((perm)=>(perm===permission))){
          list_endpoint = endpoint + '/0?subject=' + id;
        }
        else list_endpoint = endpoint_user + '/0?subject=' + id;
    }
    
    return API.post(list_endpoint)
      .then((response) => {
        let data = response?.data?.data['evaluation_list'] ? response.data.data['evaluation_list']
                    : response?.data['data'];
        return data || []
    })
    .catch((error) => {
      handleError(error, snackbarMessages.error.objects.get);
    })
  }
};